export interface OfferDtoModel {

    label?: string;
    description?: string;
    imagePath?: string;
    buyingPrice?: string;
    initialPrice?: string;
    uuid?: string;
}


export class OfferHolderModel {
    label?: string;
    description?: string;
    imagePath?: string;
    buyingPrice?: string;
    initialPrice?: string;
    partnerUuid?: string;
}
